import styled from '@emotion/styled'
import { Flex } from 'reflexbox'

import SubRouteTitle from './SubRouteTitle'

import { ArrowBackCircle, CrossIcon, LogoSmall } from '@/assets/icons'
import { ItemConfig } from '@/constants'
import { sidebarLocationPathAtom } from '@/store/sidebar'
import { store } from '@/store/store'

const MainHeader = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const Wrapper = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  height: 2.5rem;
`

export default function MobileSidebarHeader({
  route,
  onClose,
}: {
  route?: ItemConfig
  onClose: () => void
}) {
  return (
    <Wrapper>
      {route?.submenu ? (
        <SubRouteTitle
          title={route.label}
          backButton={
            <ArrowBackCircle
              onClick={() => store.set(sidebarLocationPathAtom, '')}
            />
          }
        />
      ) : (
        <MainHeader>
          <LogoSmall />
          <CrossIcon onClick={onClose} />
        </MainHeader>
      )}
    </Wrapper>
  )
}
